import "core-js/modules/es.array.find.js";
import _objectSpread from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import navMenu from '../../../../public/web/static/js/navMenu';
import { mapGetters, mapState } from 'vuex';
export default {
  name: 'Dashboard',
  created: function created() {
    console.log(this.admin_routers);
  },
  data: function data() {
    return {
      menuPathArr: [],
      zhwy_routers: navMenu // 政企信息平台人员菜单

    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['name'])), mapState({
    admin_routers: function admin_routers(state) {
      return state.permission.adminRouters;
    },
    // 后端生成菜单
    userTheme: function userTheme(state) {
      return state.user.userTheme;
    }
  })),
  methods: {
    handleZhwyMenuSelect: function handleZhwyMenuSelect(menu) {
      this.$router.push(menu.path);
      this.$store.commit('app/CHANGE_SIDEBAR', true);
      document.querySelector('.main-container').style.marginLeft = '210px';
      var chooseRouters = this.admin_routers.find(function (item) {
        if (!item.hidden && item.path !== '/') {
          return item.meta.title === menu.menuName;
        }
      });
      console.log('chooseRouters', chooseRouters);
      this.$store.dispatch('ChooseRouters', chooseRouters);
    },
    handleMenuSelect: function handleMenuSelect(menu) {
      this.menuPathArr = [];
      this.menuFormat(menu);
      this.$store.dispatch('ChooseRouters', menu);
    },
    menuFormat: function menuFormat(route) {
      this.menuPathArr.push(route.path);

      if (route.children && route.children.length > 0) {
        this.menuFormat(route.children[0]);
      }

      var menuPath = this.menuPathArr[this.menuPathArr.length - 2] + '/' + this.menuPathArr[this.menuPathArr.length - 1];
      this.$router.push(menuPath);
      this.$store.commit('app/CHANGE_SIDEBAR', true);
      document.querySelector('.main-container').style.marginLeft = '210px';
    }
  }
};